module.exports = "https://static.wmbcdn.com/uniweb/images/3b37fb17d16b419f4d5841017af2dd08.svg";